
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { 
  fetchCommunities, 
  setSearchFilter, 
  setSelectedCategory,
  clearFilters 
} from '../store/slices/communitySlice';
import './Communities.scss';

export const Communities = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const { 
    communities, 
    loading, 
    error,
    pagination,
    filters 
  } = useSelector((state) => state.community);

  const [categories, setCategories] = useState([
    { _id: '', name: 'All Communities', icon: '🌐' }
  ]);

  useEffect(() => {
    // Fetch categories from API using axios
    const fetchCategories = async () => {
      try {
        const res = await axios.get(('https://yoospeak.app:5000') + '/categories');
        const data = res.data;
        if (data && data.data) {
          // Try to extract emoji from name if present
          const apiCategories = data.data.map(cat => {
            const match = cat.name.match(/(.+?)([\u{1F300}-\u{1FAFF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}])?$/u);
            return {
              _id: cat._id,
              name: match ? match[1].trim() : cat.name,
              icon: match && match[2] ? match[2] : '',
            };
          });
          setCategories([{ _id: '', name: 'All Communities', icon: '🌐' }, ...apiCategories]);
        }
      } catch (err) {
        // Optionally handle error
        setCategories([{ _id: '', name: 'All Communities', icon: '🌐' }]);
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    loadCommunities(1);
  }, []);

  const loadCommunities = (page = 1) => {
    const params = {
      page,
      limit: 20,
      search: filters.search,
      type: filters.type,
      category: filters.selectedCategory,
    };
    dispatch(fetchCommunities(params));
  };

  const handleSearch = (e) => {
    dispatch(setSearchFilter(e.target.value));
    // Debounce search
    setTimeout(() => {
      loadCommunities(1);
    }, 500);
  };

  const handleCategoryClick = (categoryId) => {
    dispatch(setSelectedCategory(categoryId));
  };

  useEffect(() => {
    loadCommunities(1);
    // eslint-disable-next-line
  }, [filters.selectedCategory]);

  const handlePageChange = (newPage) => {
    loadCommunities(newPage);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleCommunityClick = (communityId) => {
    navigate(`/get-community/${communityId}`);
  };

  return (
    <div className="communities-page" style={{ background: '#000', minHeight: '100vh' }}>
      {/* Hero Section - Split modern style */}
      <section className="hero-section d-flex align-items-center justify-content-center" style={{ minHeight: 400, background: 'linear-gradient(120deg, #232323 60%, #fff 100%)', color: '#fff', padding: 0 }}>
        <div className="container-fluid px-0">
          <div className="row g-0 align-items-center" style={{ minHeight: 400 }}>
            <div className="col-lg-6 d-flex flex-column justify-content-center align-items-start px-5" style={{ minHeight: 400 }}>
              <h1 style={{ fontWeight: 700, fontSize: '2.8rem', color: '#FFA726', marginBottom: 16 }}>
                Discover <span style={{ color: '#2D2A7A' }}>communities</span>
              </h1>
              <p style={{ color: '#A0A4B8', fontSize: 20, marginBottom: 32 }}>
                Our mission is to help people to find the best course online and learn with expert anytime, anywhere.
              </p>
              <button className="btn" style={{ background: '#FFA726', color: '#fff', fontWeight: 600, fontSize: 18, borderRadius: 4, padding: '12px 32px' }}>
                Create Your Own
              </button>
            </div>
            <div className="col-lg-6 d-none d-lg-block">
              <img src={require('../assets/images/image.png')} alt="Discover communities" style={{ width: '100%', height: 400, objectFit: 'cover', borderTopRightRadius: 16, borderBottomRightRadius: 16 }} />
            </div>
          </div>
        </div>
      </section>


      {/* Search & Category Section - Modern grid */}
      <section className="search-section py-5" style={{ background: '#111', color: '#fff' }}>
        <div className="container">
          <div className="row mb-4">
            <div className="col-12 col-md-8 mx-auto">
              <div className="input-group input-group-lg shadow-sm rounded-3 overflow-hidden">
                <span className="input-group-text bg-white border-end-0">
                  <i className="bi bi-search text-muted"></i>
                </span>
                <input
                  type="text"
                  className="form-control border-start-0 ps-0"
                  placeholder="Search for communities..."
                  value={filters.search}
                  onChange={handleSearch}
                  style={{ background: '#222', color: '#fff', border: 'none' }}
                />
              </div>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-12 d-flex flex-wrap justify-content-center gap-3">
              {categories.map((cat, idx) => (
                <div
                  key={cat._id}
                  className={`category-card d-flex flex-column align-items-center justify-content-center rounded-4 shadow-sm ${filters.selectedCategory === cat._id ? 'border border-3 border-warning' : ''}`}
                  style={{ minWidth: 170, minHeight: 90, background: idx % 2 === 0 ? '#f5f6fa' : '#fff', color: '#232323', cursor: 'pointer', padding: 18, margin: 4, fontWeight: 600, fontSize: 18 }}
                  onClick={() => handleCategoryClick(cat._id)}
                >
                  <span style={{ fontSize: '2rem', marginBottom: 6 }}>{cat.icon}</span>
                  <span>{cat.name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Communities Grid - Modern cards */}
      <section className="communities-grid py-5" style={{ background: '#f8f9fa' }}>
        <div className="container">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h3 className="fw-bold mb-0" style={{ fontSize: 32 }}>
              {filters.selectedCategory === ''
                ? 'Best communities'
                : `${categories.find(c => c._id === filters.selectedCategory)?.name || ''} Communities`}
            </h3>
            <span className="text-muted">{pagination.total || 0} communities found</span>
          </div>

          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}

          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : communities.length === 0 ? (
            <div className="text-center py-5">
              <p className="text-muted fs-5">No communities found. Try a different search or category.</p>
            </div>
          ) : (
            <>
              <div className="row g-4">
                {communities.map((community, idx) => (
                  <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={community._id}>
                    <div className="community-card card h-100 border-0 shadow" onClick={() => handleCommunityClick(community._id)} style={{ cursor: 'pointer', borderRadius: 18, overflow: 'hidden', background: '#fff' }}>
                      <div className="position-relative">
                        <img
                          src={community.image || 'https://via.placeholder.com/400x250/6366f1/ffffff?text=Community'}
                          className="card-img-top"
                          alt={community.name}
                          style={{ height: '180px', objectFit: 'cover', borderTopLeftRadius: 18, borderTopRightRadius: 18 }}
                        />
                        <span className={`badge position-absolute top-0 end-0 m-2 ${
                          community.price > 0 ? 'bg-warning' : 'bg-success'
                        }`} style={{ fontSize: 16, padding: '8px 16px', borderRadius: 8 }}>
                          {community.price > 0 ? `$${community.price}/mo` : 'Free'}
                        </span>
                      </div>
                      <div className="card-body" style={{ padding: 20 }}>
                        <h5 className="card-title fw-bold mb-2" style={{ fontSize: 20 }}>{community.name}</h5>
                        <p className="card-text text-muted small mb-3" style={{ minHeight: 48 }}>
                          {community.description?.substring(0, 80)}
                          {community.description?.length > 80 ? '...' : ''}
                        </p>
                        <div className="d-flex justify-content-between align-items-center mt-3">
                          <div className="d-flex align-items-center">
                            <i className="bi bi-people-fill text-primary me-2"></i>
                            <span className="small text-muted">
                              {community.members || 0} members
                            </span>
                          </div>
                          <button className="btn btn-sm btn-warning rounded-pill px-3" style={{ color: '#fff', fontWeight: 600 }} onClick={(e) => { e.stopPropagation(); }}>
                            Join
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Pagination */}
              {pagination.pages > 1 && (
                <div className="d-flex justify-content-center mt-5">
                  <nav aria-label="Communities pagination">
                    <ul className="pagination pagination-lg">
                      <li className={`page-item ${pagination.page === 1 ? 'disabled' : ''}`}>
                        <button 
                          className="page-link" 
                          onClick={() => handlePageChange(pagination.page - 1)}
                          disabled={pagination.page === 1}
                        >
                          <i className="bi bi-chevron-left"></i>
                        </button>
                      </li>
                      {[...Array(pagination.pages)].map((_, index) => {
                        const pageNum = index + 1;
                        if (
                          pageNum === 1 ||
                          pageNum === pagination.pages ||
                          (pageNum >= pagination.page - 2 && pageNum <= pagination.page + 2)
                        ) {
                          return (
                            <li key={pageNum} className={`page-item ${pagination.page === pageNum ? 'active' : ''}`}>
                              <button 
                                className="page-link" 
                                onClick={() => handlePageChange(pageNum)}
                              >
                                {pageNum}
                              </button>
                            </li>
                          );
                        } else if (
                          pageNum === pagination.page - 3 ||
                          pageNum === pagination.page + 3
                        ) {
                          return <li key={pageNum} className="page-item disabled"><span className="page-link">...</span></li>;
                        }
                        return null;
                      })}
                      <li className={`page-item ${pagination.page === pagination.pages ? 'disabled' : ''}`}>
                        <button 
                          className="page-link" 
                          onClick={() => handlePageChange(pagination.page + 1)}
                          disabled={pagination.page === pagination.pages}
                        >
                          <i className="bi bi-chevron-right"></i>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              )}
            </>
          )}
        </div>
      </section>
    </div>
  );
};
